(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6948],{

/***/ 38562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var firebase_remote_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12971);
/* harmony import */ var utils_firebase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18945);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
 // import getConfig from "next/config";







var ElectionsWidget = function ElectionsWidget() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    electionExitPollToggle: false,
    electionResultToggle: true,
    vidhansabhaResultToggle: true,
    resultVersion: 1.6,
    exitPollVersion: 1.2,
    electionYear: 2024,
    isElectionAlpha: true,
    keyCandidate: true
  }),
      publicRuntimeConfig = _useState[0],
      setPublicRunTimeConfig = _useState[1]; // const { publicRuntimeConfig } = getConfig();


  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
      lokExit = _useState2[0],
      setLokExit = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (true) {
      var remoteConfig = (0,firebase_remote_config__WEBPACK_IMPORTED_MODULE_1__/* .getRemoteConfig */ .sN)(utils_firebase__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
      remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
      (0,firebase_remote_config__WEBPACK_IMPORTED_MODULE_1__/* .fetchAndActivate */ .xS)(remoteConfig).then(function () {
        var titleData = (0,firebase_remote_config__WEBPACK_IMPORTED_MODULE_1__/* .getString */ .KF)(remoteConfig, "electionKeys");
        var parsedData = JSON.parse(titleData);
        setPublicRunTimeConfig(parsedData); // console.log("Election Keys are ", (parsedData))
        // setVideoUrl(titleData);
      })["catch"](function (err) {
        console.error(err);
      });
    }
  }, []); // console.log(
  //   "ElectionWidges are",
  //   publicRuntimeConfig?.electionExitPollToggle
  // );

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: (publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.electionExitPollToggle) === true && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: "election-result-tally",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h2", {
        style: {
          paddingLeft: "10px",
          fontWeight: "700",
          fontSize: "22px",
          paddingTop: "10px",
          paddingBottom: "5px",
          background: "white"
        },
        children: "\u090F\u0917\u094D\u091C\u093F\u091F \u092A\u094B\u0932"
      }), lokExit ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("iframe", {
        width: "100%",
        height: "370px",
        scrolling: "no" // src= "https://electionresults.intoday.in/elections/2024/loksabha-elections/html/exit-poll/lok-sabha-exit-poll.html?site=lallantop&theme=1&v=1.0"
        ,
        src: "https://electionresults.intoday.in/elections/2024/loksabha-elections/html/loksabhastate-exitpoll/lok-sabha-exit-poll.html?site=lallantop&theme=1&v=5.0"
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("iframe", {
        width: "100%",
        height: "340px",
        scrolling: "no",
        src: "https://electionresults.intoday.in/elections/2024/assembly-elections/html/exit-poll/assembly-exit-poll.html?site=lallantop&device=web&v=5.1"
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ElectionsWidget);

/***/ }),

/***/ 5317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var api_commonConstants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96781);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10682);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


 // import CustomIframe from './CustomIframe';





function Tally(_ref) {
  var masterConfig = _ref.masterConfig,
      showExitTally = _ref.showExitTally,
      showResultTally = _ref.showResultTally,
      stateName = _ref.stateName;
  var size = (0,api_commonConstants__WEBPACK_IMPORTED_MODULE_1__/* .useWindowSize */ .iP)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [showExitTally != false && (masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exittally) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: size.width < 768 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "result-page",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
          style: {
            fontSize: "27px",
            color: "#D9368B",
            fontWeight: "800"
          },
          children: "\u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u090F\u0917\u094D\u095B\u093F\u091F \u092A\u094B\u0932"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
            scrolling: "no",
            src: !stateName ? "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exittally_URL) : "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exittally_URL, "&state_name=").concat(stateName),
            width: "100%",
            height: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exitpolltally_height_mobile
          })
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: "result-page  ",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
            style: {
              fontSize: "27px",
              color: "#D9368B",
              fontWeight: "800"
            },
            children: "\u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u090F\u0917\u094D\u095B\u093F\u091F \u092A\u094B\u0932"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
              scrolling: "no",
              src: !stateName ? "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exittally_URL) : "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exittally_URL, "&state_name=").concat(stateName),
              width: "100%",
              height: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exitpolltally_height_web
            })
          })]
        })
      })
    }), showResultTally != false && (masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: size.width < 768 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "result-page-big",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
          style: {
            fontSize: "27px",
            color: "#D9368B",
            fontWeight: "800"
          },
          children: "\u0926\u093F\u0932\u094D\u0932\u0940 \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
            scrolling: "no",
            src: !stateName ? "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_URL) : "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_URL, "&state_name=").concat(stateName),
            width: "100%",
            height: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_height_mobile
          })
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: "result-page-big",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
            style: {
              fontSize: "27px",
              color: "#D9368B",
              fontWeight: "800"
            },
            children: "\u0926\u093F\u0932\u094D\u0932\u0940 \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
              scrolling: "no",
              src: !stateName ? "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_URL) : "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_URL, "&state_name=").concat(stateName),
              width: "100%",
              height: size.width != 768 && size.width <= 1000 ? masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_height_tab_internal : masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_height_web // height={(size.width != 768 && size.width <= 1000 )? masterConfig.Maharashtra_Resulttally_height_tab_internal   :
              //   masterConfig
              //     .Maharashtra_Resulttally_height_web
              // }
              // height={(window.innerWidth != 768 && window.innerWidth <= 1000) ? masterConfig?.Maharashtra_Resulttally_height_tab_internal :  masterConfig?.Maharashtra_Resulttally_height_web}

            })
          })]
        })
      })
    }), (masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.BypollResulttally) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: size.width < 768 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "result-page-big",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
          style: {
            fontSize: "27px",
            color: "#D9368B",
            fontWeight: "800"
          },
          children: "\u0909\u092A\u091A\u0941\u0928\u093E\u0935 \u0930\u093F\u091C\u0932\u094D\u091F"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
            scrolling: "no",
            src: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.BypollResulttally_URL,
            width: "100%",
            height: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Bypoll_Resulttally_height_mobile
          })
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "result-page-big",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
          style: {
            fontSize: "27px",
            color: "#D9368B",
            fontWeight: "800"
          },
          children: "\u0909\u092A\u091A\u0941\u0928\u093E\u0935 \u0930\u093F\u091C\u0932\u094D\u091F"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
            scrolling: "no",
            src: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.BypollResulttally_URL,
            width: "100%",
            height: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Bypoll_Resulttally_height_web
          })
        })]
      })
    })]
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (Tally);

/***/ }),

/***/ 7725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



// import Link from "next/link";
var NotFound = function NotFound() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
    className: "container",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
      className: "page-not-found",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        children: "\u0915\u094D\u0937\u092E\u093E \u0915\u0930\u0947\u0902"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        children: "\u0906\u092A\u0915\u0947 \u0926\u094D\u0935\u093E\u0930\u093E \u0905\u0928\u0941\u0930\u094B\u0927 \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u092A\u0947\u091C \u0909\u092A\u0932\u092C\u094D\u200D\u0927 \u0928\u0939\u0940\u0902 \u0939\u0948."
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
        children: ["\u0939\u094B\u092E \u092A\u0947\u091C \u092A\u0930 \u091C\u093E\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u092F\u0939\u093E\u0902 ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
          href: "/",
          passHref: true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: "\u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902"
          })
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (NotFound);

/***/ }),

/***/ 73557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ kaunJeetaIndex; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/localization/i8intl.js + 2 modules
var i8intl = __webpack_require__(54269);
// EXTERNAL MODULE: ./src/api/commonConstants.js
var commonConstants = __webpack_require__(96781);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/elections-2023/ElectionsWidget.js
var ElectionsWidget = __webpack_require__(38562);
// EXTERNAL MODULE: ./src/constants/MasterConfigContext.js
var MasterConfigContext = __webpack_require__(39712);
// EXTERNAL MODULE: ./src/api/constants.js
var constants = __webpack_require__(9041);
// EXTERNAL MODULE: ./src/components/tally/Tally.jsx
var Tally = __webpack_require__(5317);
// EXTERNAL MODULE: ./src/constants/state.js
var state = __webpack_require__(25613);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/vidhansabha/KaunJeetaD.js








 // import Link from "next/link";



 // import getConfig from "next/config";

 // import { FormattedMessage } from "react-intl";








function KaunJeetaD(props) {
  var _useContext, _colorOptions, _props$propData, _electionTopicData$, _electionTopicData$2, _electionTopicData$3, _electionTopicData$4, _electionTopicData$5, _electionTopicData$6, _electionTopicData$7;

  var electionsData = (_useContext = (0,react.useContext)(MasterConfigContext/* MasterConfigContext */.d)) === null || _useContext === void 0 ? void 0 : _useContext[props.masterKey]; // //uncomment it later
  // electionsData = {
  //   ...electionsData,
  //   electionYear : 2019
  // }
  // var electionYear = electionsData?.electionYear;

  var electionYear = electionsData === null || electionsData === void 0 ? void 0 : electionsData.electionYear_KJKH_listing; // var electionYear = 2020;

  var dryRun = electionsData === null || electionsData === void 0 ? void 0 : electionsData.dryRun; // var electionYear = ${displayYear};
  // const showProfilePage = electionsData?.showProfilePage;
  // var electionYear = ${displayYear}

  var displayYear = electionsData === null || electionsData === void 0 ? void 0 : electionsData.displayYear;

  var _useState = (0,react.useState)(""),
      language = _useState[0],
      setLanguage = _useState[1];

  var _useState2 = (0,react.useState)([]),
      electionTopicData = _useState2[0],
      setElectionTopicData = _useState2[1];

  var router = (0,next_router.useRouter)();
  console.log("calleddd2", router.asPath.charAt(0) === "/" ? router.asPath.substring(1) : router.asPath);
  var size = (0,commonConstants/* useWindowSize */.iP)();
  (0,react.useEffect)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var _dataFetched, _dataFetched$result;

    var dataFetched, datas;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch("".concat(constants/* baseUrl */.FH, "/web/postListByCategory/election?limit=5&skip=1&type=text,video,liveblog"));

          case 2:
            datas = _context.sent;
            _context.next = 5;
            return datas === null || datas === void 0 ? void 0 : datas.json();

          case 5:
            dataFetched = _context.sent;
            dataFetched = (_dataFetched = dataFetched) === null || _dataFetched === void 0 ? void 0 : (_dataFetched$result = _dataFetched.result) === null || _dataFetched$result === void 0 ? void 0 : _dataFetched$result.entities;
            setElectionTopicData(dataFetched);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), []);
  (0,react.useEffect)(function () {
    setLanguage((0,i8intl/* getLanguage */.G3)());
  }, []);
  var mainUrl = "all";

  var _useState3 = (0,react.useState)(props === null || props === void 0 ? void 0 : props.winnersData2024),
      winnersData = _useState3[0],
      setWinnersData = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      prevData = _useState4[0],
      setPrevData = _useState4[1];

  function getNewDataList() {
    return _getNewDataList.apply(this, arguments);
  } // useEffect(() => {
  //   if (electionYear == props.propData.currentYear) {
  //     getNewDataList();
  //   }
  // }, [electionYear]);


  function _getNewDataList() {
    _getNewDataList = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fetch("https://akm-img-a-in.tosshub.com/sites/elections/".concat(displayYear, "/assembly/json/state-master/jammu-and-kashmir-").concat(electionYear, "-all-consituency.json")).then( /*#__PURE__*/function () {
                var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(data) {
                  var data1;
                  return regenerator_default().wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return data.json();

                        case 2:
                          data1 = _context2.sent;
                          setWinnersData(data1 === null || data1 === void 0 ? void 0 : data1.seat_data);

                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x) {
                  return _ref4.apply(this, arguments);
                };
              }());

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _getNewDataList.apply(this, arguments);
  }

  var options = [{
    value: 0,
    label: "2019"
  } // {
  //   value: 2,
  //   label: '${displayYear}'
  // }
  ];
  var colorOptions = (_colorOptions = {
    llt: "#eb0e8c",
    tg: "#d9368b",
    mz: "#8ab3dc",
    mp: "#0c8a70",
    cg: "#2d8468"
  }, (0,defineProperty/* default */.Z)(_colorOptions, "llt", "#d9368b"), (0,defineProperty/* default */.Z)(_colorOptions, "rj", "#fed029"), (0,defineProperty/* default */.Z)(_colorOptions, "up", "#f6523e"), (0,defineProperty/* default */.Z)(_colorOptions, "gj", "#f362b3"), (0,defineProperty/* default */.Z)(_colorOptions, "ct", "#B71F33"), (0,defineProperty/* default */.Z)(_colorOptions, "mt", "#f92929"), _colorOptions); // async function getWinnersList() {
  //   await fetch(
  //     "https://akm-img-a-in.tosshub.com/sites/elections/${displayYear}/Vidhansabha/json/master/india-seat-wise-livedata-master.json"
  //   ).then(async (data) => {
  //     const data1 = await data.json();
  //     setWinnersData(data1?.data);
  //   });
  // }
  // useEffect(() => {
  //   getWinnersList();
  // }, []);

  (0,react.useEffect)(function () {
    if ((winnersData === null || winnersData === void 0 ? void 0 : winnersData.length) > 0) {
      setPrevData(winnersData);
    }
  }, [winnersData]);
  console.log("Winners data 2", props);

  function findSearchData(value) {
    var query = value.toLowerCase();
    var prevData = winnersData;
    var newData = prevData.filter(function (item) {
      return item.ac_name.toLowerCase().includes(query) || item.constitutency_hi.toLowerCase().includes(query) || item.name.toLowerCase().includes(query);
    });
    setPrevData(newData);
  }

  function findSearchData2024(value) {
    var query = value.toLowerCase();
    var prevData = winnersData;
    var newData = prevData.filter(function (item) {
      return item.seat_name.toLowerCase().includes(query) || item.candidate_name.toLowerCase().includes(query);
    });
    setPrevData(newData);
  }

  (0,react.useEffect)(function () {
    setLanguage((0,i8intl/* getLanguage */.G3)());
    setTimeout(function () {
      window.googletag = window.googletag || {
        cmd: []
      };

      if (window.screen.width > 600) {
        googletag.cmd.push(function () {
          googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_ATF_728x90", [[728, 90], [970, 250], [970, 90]], "div-gpt-ad-1701945163318-0").addService(googletag.pubads());
          googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_MTF_1_728x90", [728, 90], "div-gpt-ad-1701945220410-1").addService(googletag.pubads()); //  googletag.defineOutOfPageSlot('/1007232/Lallantop_Mobile_HP_Mweb_Interstitial',googletag.enums.OutOfPageFormat.INTERSTITIAL).addService(googletag.pubads());

          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", [""]);
          googletag.pubads().setTargeting("Keywords", "");
          googletag.enableServices();
        });
      } else {
        googletag.cmd.push(function () {
          googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_ATF_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-0").addService(googletag.pubads());
          googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_MTF_1_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-1").addService(googletag.pubads());
          googletag.defineSlot("/1007232/Lallantop_Mobile_HP_Bottom_320x50", [320, 50], "div-gpt-ad-1701946324333-0").addService(googletag.pubads());
          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", [""]);
          googletag.pubads().setTargeting("Keywords", "");
          googletag.enableServices();
        });
      }

      googletag.pubads().refresh(); // console.log("apstag", typeof apstag);
      // if (typeof apstag !== "undefined") {
      //   apstag.init({
      //     pubID: "7f0bbd82-5a13-48ec-9950-fcb028b1546c",
      //     adServer: "googletag",
      //     bidTimeout: 2e3,
      //   });
      //   // request the bids for the four googletag slots
      //   apstag.fetchBids(
      //     {
      //       slots: [
      //       ],
      //     },
      //     function (bids) {
      //       // set apstag bids, then trigger the first request to GAM
      //       googletag.cmd.push(function () {
      //         apstag.setDisplayBids();
      //         googletag.pubads().refresh();
      //       });
      //     }
      //   );
      // }
    }, 500);
  }, []);
  console.log("masterconfig ", props);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        id: "my-script-detail",
        type: "application/ld+json",
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "http://schema.org/",
            "@type": "WebPage",
            name: "".concat(props === null || props === void 0 ? void 0 : props.stateName, " Assembly Election Result ").concat(displayYear, ": ").concat(props === null || props === void 0 ? void 0 : props.stateName, " Vidhan Sabha Parinam result in hindi | ").concat(props === null || props === void 0 ? void 0 : props.stateHindi, " \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F \u091A\u0941\u0928\u093E\u0935"),
            description: "".concat(props === null || props === void 0 ? void 0 : props.stateName, " Chunav Result ").concat(displayYear, ": Know the latest updates of ").concat(props === null || props === void 0 ? void 0 : props.stateName, " assembly election result(").concat(props === null || props === void 0 ? void 0 : props.stateHindi, " \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F \u091A\u0941\u0928\u093E\u0935 ).\n              \u091C\u093E\u0928\u093F\u090F ").concat(props === null || props === void 0 ? void 0 : props.stateHindi, " chunav \u092E\u0947\u0902 \u0915\u094C\u0928 \u091A\u0932 \u0930\u0939\u093E \u0906\u0917\u0947 \u0914\u0930 \u0915\u094C\u0928 \u092A\u0940\u091B\u0947? \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 \u0928\u0924\u0940\u091C\u0947, \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 \u0915\u0947 \u0930\u0941\u091D\u093E\u0928 \u0914\u0930 \u0928\u0924\u0940\u091C\u0947, \u0938\u092C\u0938\u0947 \u092A\u0939\u0932\u0947 \u092F\u0939\u093E\u0902 \u092A\u0922\u093C\u0947."),
            keywords: "".concat(props === null || props === void 0 ? void 0 : props.stateName, " Vidhan Sabha Chunav ").concat(displayYear, ", ").concat(props === null || props === void 0 ? void 0 : props.stateName, " election results,\n          Vidhan Sabha election ").concat(props === null || props === void 0 ? void 0 : props.stateName, ",\n          ").concat(props === null || props === void 0 ? void 0 : props.stateName, " assembly election result,\n          Chunav natije ").concat(props === null || props === void 0 ? void 0 : props.stateName, ",\n          ").concat(props === null || props === void 0 ? void 0 : props.stateName, " election ").concat(displayYear, ",\n          ").concat(props === null || props === void 0 ? void 0 : props.stateName, " assembly Election Updates in Hindi,\n          ").concat(props === null || props === void 0 ? void 0 : props.stateHindi, " \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935,\n          ").concat(props === null || props === void 0 ? void 0 : props.stateHindi, " \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F,\n          ").concat(props === null || props === void 0 ? void 0 : props.stateHindi, " \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F ").concat(displayYear),
            url: "".concat("https://www.thelallantop.com").concat(router.asPath),
            publisher: {
              "@type": "Organization",
              name: "The Lallantop",
              url: "https://www.thelallantop.com/",
              logo: {
                "@type": "ImageObject",
                url: "https://www.thelallantop.com/assets/images/lallatop-logo-m.svg",
                width: 600,
                height: 60
              }
            }
          })
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        id: "my-script-detail",
        type: "application/ld+json",
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [{
              "@type": "ListItem",
              position: 1,
              item: {
                "@id": "".concat("https://www.thelallantop.com/"),
                name: "Home"
              }
            }, {
              "@type": "ListItem",
              position: 2,
              item: {
                name: "Election",
                "@id": "".concat("https://www.thelallantop.com/", "election")
              }
            }, {
              "@type": "ListItem",
              position: 3,
              item: {
                name: "".concat(props === null || props === void 0 ? void 0 : props.stateName, " Election Results"),
                "@id": "".concat("https://www.thelallantop.com/").concat(router.asPath.charAt(0) === "/" ? router.asPath.substring(1) : router.asPath)
              }
            }]
          })
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        id: "my-script-detail",
        type: "application/ld+json",
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SiteNavigationElement",
            name: ["होम", "चुनाव", "न्यूज़", "एंटरटेनमेंट", "ऑडनारी", "टेक्नोलॉजी", "पड़ताल", "बिज़नेस", "लल्लनख़ास", "स्पोर्ट्स", "रंगरूट"],
            url: ["https://www.thelallantop.com/", "https://www.thelallantop.com/election", "https://www.thelallantop.com/news", "https://www.thelallantop.com/entertainment", "https://www.thelallantop.com/oddnaari", "https://www.thelallantop.com/technology", "https://www.thelallantop.com/factcheck", "https://www.thelallantop.com/business", "https://www.thelallantop.com/lallankhas", "https://www.thelallantop.com/sports", "https://www.thelallantop.com/education"]
          })
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "preconnect",
        crossOrigin: "true",
        href: "https://static.chartbeat.com"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        async: true,
        dangerouslySetInnerHTML: {
          __html: "\n            (function () {\n              var _sf_async_config = window._sf_async_config = (window._sf_async_config || {});\n              _sf_async_config.uid = 60355;\n              _sf_async_config.domain = 'thelallantop.com';\n              _sf_async_config.useCanonical = true;\n              _sf_async_config.useCanonicalDomain = true;\n              _sf_async_config.sections = 'home'; \n              _sf_async_config.authors = '';\n              function loadChartbeat() {\n                  var e = document.createElement('script');\n                  var n = document.getElementsByTagName('script')[0];\n                  e.type = 'text/javascript';\n                  e.async = true;\n                  e.src = '//static.chartbeat.com/js/chartbeat.js';\n                  n.parentNode.insertBefore(e, n);\n              }\n              loadChartbeat();\n          })();\n       "
        },
        strategy: "afterInteractive",
        id: "chartbeat",
        type: "text/javascript"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: "".concat(props === null || props === void 0 ? void 0 : props.stateName, " Assembly Election Result ").concat(displayYear, ": ").concat(props === null || props === void 0 ? void 0 : props.stateName, " Vidhan Sabha Parinam result in hindi | ").concat(props === null || props === void 0 ? void 0 : props.stateHindi, " \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F \u091A\u0941\u0928\u093E\u0935"),
      description: "".concat(props === null || props === void 0 ? void 0 : props.stateName, " Chunav Result ").concat(displayYear, ": Know the latest updates of ").concat(props === null || props === void 0 ? void 0 : props.stateName, " assembly election result(").concat(props === null || props === void 0 ? void 0 : props.stateHindi, " \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F \u091A\u0941\u0928\u093E\u0935 ).\n\u091C\u093E\u0928\u093F\u090F ").concat(props === null || props === void 0 ? void 0 : props.stateHindi, " chunav \u092E\u0947\u0902 \u0915\u094C\u0928 \u091A\u0932 \u0930\u0939\u093E \u0906\u0917\u0947 \u0914\u0930 \u0915\u094C\u0928 \u092A\u0940\u091B\u0947? \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 \u0928\u0924\u0940\u091C\u0947, \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 \u0915\u0947 \u0930\u0941\u091D\u093E\u0928 \u0914\u0930 \u0928\u0924\u0940\u091C\u0947, \u0938\u092C\u0938\u0947 \u092A\u0939\u0932\u0947 \u092F\u0939\u093E\u0902 \u092A\u0922\u093C\u0947."),
      canonical: "".concat("https://www.thelallantop.com").concat(router.asPath)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "keywords",
      content: "".concat(props === null || props === void 0 ? void 0 : props.stateName, " Vidhan Sabha Chunav ").concat(displayYear, ", ").concat(props === null || props === void 0 ? void 0 : props.stateName, " election results,\n          Vidhan Sabha election ").concat(props === null || props === void 0 ? void 0 : props.stateName, ",\n          ").concat(props === null || props === void 0 ? void 0 : props.stateName, " assembly election result,\n          Chunav natije ").concat(props === null || props === void 0 ? void 0 : props.stateName, ",\n          ").concat(props === null || props === void 0 ? void 0 : props.stateName, " election ").concat(displayYear, ",\n          ").concat(props === null || props === void 0 ? void 0 : props.stateName, " assembly Election Updates in Hindi,\n          ").concat(props === null || props === void 0 ? void 0 : props.stateHindi, " \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935,\n          ").concat(props === null || props === void 0 ? void 0 : props.stateHindi, " \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F,\n          ").concat(props === null || props === void 0 ? void 0 : props.stateHindi, " \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F ").concat(displayYear)
    }), size.width > 600 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: size.width >= 600 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          position: "relative",
          display: "flex",
          justifyContent: "center"
        },
        children: [router.asPath.includes("election") && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          style: {
            position: "relative"
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/assets/images/election-background-3.png",
            style: {
              position: "relative",
              width: "100%",
              height: "298px"
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/assets/images/left-election-top-2.png",
            width: "",
            height: "170px",
            style: {
              position: "absolute",
              bottom: "10px",
              left: "10px"
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: router.asPath.includes("haryana-assembly") ? "/assets/images/right-election-top-2.png" : router.asPath.includes("jammu-kashmir-assembly") ? "/assets/images/jammu-kashmir.png" : "/assets/images/indian-map.png",
            width: "",
            height: "250px",
            style: {
              position: "absolute",
              bottom: "0",
              right: "0px"
            }
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
          align: "center",
          style: {
            position: router.asPath.includes("/election") ? "absolute" : "relative",
            top: router.asPath.includes("/election") ? "22px" : "0px"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "container-row py-2",
            align: "center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              style: {
                fontSize: "11px",
                color: "#b7b7b7",
                textAlign: "center",
                marginBottom: "0px"
              },
              children: "Advertisement"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              id: "div-gpt-ad-1701945163318-0",
              style: {
                minWidth: "300px",
                minHeight: "100px",
                display: "block !important",
                alignContent: "center",
                textAlign: "-webkit-center"
              },
              className: "ads-auto-resize",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                  __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945163318-0')})"
                }
              })
            })]
          })
        })]
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          position: "relative",
          width: "100%"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "/assets/images/election-background-mobile.png",
          style: {
            position: "relative",
            width: "100%",
            height: "auto"
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "/assets/images/election-left-mobile.png",
          width: "",
          height: "70px",
          style: {
            position: "absolute",
            bottom: "10px",
            left: "10px"
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: router.asPath.includes("haryana-assembly") ? "/assets/images/right-election-top-2.png" : router.asPath.includes("jammu-kashmir-assembly") ? "/assets/images/jammu-kashmir.png" : "/assets/images/indian-map.png",
          width: "",
          height: "90px",
          style: {
            position: "absolute",
            bottom: "0",
            right: "0px"
          }
        })]
      })
    }), size.width > 768 ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          width: "max-content",
          margin: "auto",
          gap: "68px",
          height: "80px",
          marginTop: "15px",
          borderRadius: "12px",
          padding: "0px 30px"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            display: "flex",
            justifyContent: "center",
            // paddingTop: "1rem",
            gap: "8px",
            // cursor: "pointer",
            backgroundColor: "white",
            paddingLeft: "0px"
          } // onClick={() =>
          //   window.open("/election/lok-sabha-chunav-${displayYear}", "_self")
          // }
          ,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/assets/images/assembly-chunav.png",
            width: "408.56px",
            height: "58.21px",
            style: {
              alignSelf: "center"
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "class": "divCategoriesSchedule2 snipcss-eqdpv",
          style: {
            margin: "0px 0px",
            // backgroundColor: "rgb(217, 54, 139)",
            paddingLeft: "15px",
            alignContent: "center"
          },
          children: props.breadCrump.length > 0 && props.breadCrump.map(function (item, index) {
            return electionsData[item.keyToShow] != false ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: item.url,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: item.displayText
              })
            }, index) : null;
          })
        })]
      })
    }) :
    /*#__PURE__*/
    // mobile breadcrump
    (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            display: "flex",
            justifyContent: "center",
            paddingTop: "1rem",
            gap: "8px",
            // cursor: "pointer",
            paddingBottom: "1rem",
            backgroundColor: "white",
            marginTop: "10px"
          } // onClick={() =>
          //   window.open("/election/lok-sabha-chunav-${displayYear}", "_self")
          // }
          ,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/assets/images/assembly-chunav.png",
            width: "240px",
            height: "auto",
            style: {
              alignSelf: "center"
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "class": "divCategoriesSchedule2 snipcss-eqdpv",
          style: {
            margin: "-1px 0px",
            backgroundColor: "white",
            paddingLeft: "15px",
            paddingBottom: "1rem",
            display: "flex",
            justifyContent: ""
          },
          children: props.breadCrump.length > 0 && props.breadCrump.map(function (item, index) {
            return electionsData[item.keyToShow] != false ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: item.url,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: item.displayText
              })
            }, index) : null;
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), size.width <= 768 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container-row py-2",
      align: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        style: {
          fontSize: "11px",
          color: "#b7b7b7",
          textAlign: "center",
          marginBottom: "0px"
        },
        children: "Advertisement"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        id: "div-gpt-ad-1701946028239-0",
        style: {
          minWidth: "300px",
          minHeight: "260px",
          display: "block !important",
          alignContent: "center",
          textAlign: "-webkit-center"
        },
        className: "ads-auto-resize",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
          type: "text/javascript",
          dangerouslySetInnerHTML: {
            __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})"
          }
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tally/* default */.Z, {
      stateName: state/* stateData */.i[props.electionState].tallyState,
      masterConfig: electionsData
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      className: "breadcrumb assembly-breadcrumb",
      style: {
        margin: "auto",
        marginBottom: "20px"
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "/",
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            "aria-label": "Lallantop Home",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("i", {
              className: "icon-cat-home"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Home"
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "/election/",
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            "aria-label": "Lallantop Home",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Election"
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          children: [" ", props.stateName, " Election Results"]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ElectionsWidget/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "lok-sabha-main",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "header-category-page"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("h1", {
        children: [props === null || props === void 0 ? void 0 : (_props$propData = props.propData) === null || _props$propData === void 0 ? void 0 : _props$propData.stateHindi, " \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 \u0930\u093F\u091C\u0932\u094D\u091F ", displayYear]
      }), electionYear != props.propData.currentYear ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          fontSize: "18px"
        },
        children: props.propData.otherYearPara
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          fontSize: "18px"
        },
        children: props.propData.currentYearPara
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), console.log("All props ", props), /*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
        className: "winner-box-header",
        style: {
          fontWeight: 600,
          borderColor: colorOptions["llt"],
          fontSize: "26px"
        },
        children: [electionYear, " \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F", " "]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "result-page",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "tp-data"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "winners-list-box",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            style: {
              fontSize: "22px",
              fontWeight: "700"
            },
            children: "\u0928\u093F\u0930\u094D\u0935\u093E\u091A\u0928 \u0915\u094D\u0937\u0947\u0924\u094D\u0930 \u0914\u0930 \u0909\u092E\u094D\u092E\u0940\u0926\u0935\u093E\u0930"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "assembly-buttons",
            children: props.propData.tabs.map(function (item) {
              return (electionsData === null || electionsData === void 0 ? void 0 : electionsData[item.showKey]) !== false ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                onClick: function onClick() {
                  window.location.href = item.url;
                },
                className: item.showActive ? "assembly-buttons-btn-active" : "assembly-buttons-btn",
                children: item.text
              }) : null;
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              "class": "search_cont snipcss0-0-0-1 snipcss-rNdJP",
              children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                type: "text",
                id: "winner_list",
                placeholder: "Search for names..",
                title: "Type in a name",
                autocomplete: "off",
                "class": "snipcss0-1-1-2",
                onChange: function onChange(e) {
                  if (electionYear == props.propData.currentYear) {
                    findSearchData2024(e.target.value);
                  } else {
                    findSearchData(e.target.value);
                  }
                }
              }), " "]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              width: "100%",
              overflow: "auto"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("table", {
              style: {
                tableLayout: "fixed"
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                style: {
                  backgroundColor: colorOptions["llt"]
                },
                children: "\u0928\u093F\u0930\u094D\u0935\u093E\u091A\u0928 \u0915\u094D\u0937\u0947\u0924\u094D\u0930"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                style: {
                  backgroundColor: colorOptions["llt"]
                },
                children: "\u092A\u093E\u0930\u094D\u091F\u0940"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                style: {
                  backgroundColor: colorOptions["llt"]
                },
                children: "\u0935\u093F\u091C\u0947\u0924\u093E"
              }), electionYear != props.propData.currentYear && prevData.map(function (con, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                  className: index % 2 !== 0 ? "oddColor" : "",
                  style: {
                    letterSpacing: "normal",
                    fontSize: "18px",
                    width: "50%"
                  },
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                    onClick: function onClick() {
                      return window.open("".concat("https://www.thelallantop.com").concat(router.asPath, "/").concat(con === null || con === void 0 ? void 0 : con.ac_name.toLowerCase().replace(/[^a-zA-Z ]/g, "").split(" ").join("-"), "-constituency-result/").concat(con === null || con === void 0 ? void 0 : con.id), "_self");
                    },
                    style: {
                      textAlign: "center",
                      cursor: "pointer",
                      textDecoration: "underline"
                    },
                    children: "".concat(con === null || con === void 0 ? void 0 : con.constitutency_hi, " ")
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                    style: {
                      textAlign: "center",
                      justifyContent: "center"
                    },
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      style: {
                        display: "inline-block"
                      },
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        src: con === null || con === void 0 ? void 0 : con.party_logo,
                        style: {
                          marginRight: "20px"
                        },
                        width: "20px",
                        height: "20px"
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      style: {
                        display: "inline-block"
                      },
                      children: con === null || con === void 0 ? void 0 : con.filter_party
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                    // onClick={() =>{
                    //   electionsData.ShowProfileFromListing ?
                    //   window.open(
                    //     `${process.env.NEXT_PUBLIC_BASE_URL}/election/${
                    //       props?.electionState
                    //     }/candidate-${(
                    //       con?.candidate_name || con?.name
                    //     )
                    //       ?.toLowerCase()
                    //       .replace(/[^a-zA-Z ]/g, "")
                    //       .split(" ")
                    //       .join("-")}-${
                    //       con?.id}`,
                    //     "_self"
                    //   ) : ""
                    // }
                    // }
                    className: "winner-name",
                    style:  false ? 0 : {
                      textAlign: "center",
                      fontSize: "18px"
                    },
                    children: con === null || con === void 0 ? void 0 : con.name
                  })]
                }, index);
              }), electionYear == props.propData.currentYear && (winnersData === null || winnersData === void 0 ? void 0 : winnersData.length) > 0 && prevData.map(function (con, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                  children: size.width < 768 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                    className: index % 2 !== 0 ? "oddColor" : "",
                    style: {
                      letterSpacing: "normal",
                      fontSize: "15px"
                    },
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                      onClick: function onClick() {
                        return window.open("".concat("https://www.thelallantop.com").concat(router.asPath, "/").concat(con === null || con === void 0 ? void 0 : con.seat_name.toLowerCase().replace(/[^a-zA-Z ]/g, "").split(" ").join("-"), "-constituency-result/").concat(con === null || con === void 0 ? void 0 : con.id), "_self");
                      },
                      style: {
                        textAlign: "center",
                        cursor: "pointer",
                        textDecoration: "underline"
                      },
                      children: "".concat(con === null || con === void 0 ? void 0 : con.constitutency_hi, " (").concat(con === null || con === void 0 ? void 0 : con.seat_name, ")")
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                      style: {
                        textAlign: "center",
                        padding: "5px"
                      },
                      children: (con === null || con === void 0 ? void 0 : con.party_name) === "Result Awaited" ? "Result Awaited" : dryRun == true ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                            src: con === null || con === void 0 ? void 0 : con.party_logo // style={{ marginRight: "20px" }}
                            ,
                            width: "20px",
                            height: "20px"
                          })
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          children: con === null || con === void 0 ? void 0 : con.party_name
                        })]
                      }) : "Result Awaited"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                      className: "winner-name",
                      style: {
                        padding: "6px",
                        // display: "flex",
                        fontSize: "15px",
                        justifyContent: "space-between",
                        textAlign: "center"
                      },
                      children: (con === null || con === void 0 ? void 0 : con.candidate_name) === "Result Awaited" ? "Result Awaited" : dryRun == true ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [(con === null || con === void 0 ? void 0 : con.seat_status) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                            src: (con === null || con === void 0 ? void 0 : con.seat_status) === "WON" ? "https://static.thelallantop.com/images/post/1728033937028_thumbs_up.webp" : (con === null || con === void 0 ? void 0 : con.seat_status) === "TRAILING" ? "https://static.thelallantop.com/images/post/1728033833372_arrow_down.webp" : (con === null || con === void 0 ? void 0 : con.seat_status) === "LEADING" ? "https://static.thelallantop.com/images/post/1728033863072_arrow_up.webp" : "https://static.thelallantop.com/images/post/1728033907858_thumbs_down.webp" // style={{ marginLeft: "20px" }}
                            ,
                            width: "25px",
                            height: "25px"
                          })
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          //add link here
                          onClick: function onClick() {
                            var _ref2;

                            electionsData.ShowProfileFromListing && (con === null || con === void 0 ? void 0 : con.candidate_name) != 'NOTA' ? window.open("".concat("https://www.thelallantop.com", "/election/").concat(props === null || props === void 0 ? void 0 : props.electionState, "/candidate-").concat((_ref2 = (con === null || con === void 0 ? void 0 : con.candidate_name) || (con === null || con === void 0 ? void 0 : con.name)) === null || _ref2 === void 0 ? void 0 : _ref2.toLowerCase().replace(/[^a-zA-Z ]/g, "").split(" ").join("-"), "-").concat(electionsData !== null && electionsData !== void 0 && electionsData.IDKeyInListing ? con === null || con === void 0 ? void 0 : con[electionsData === null || electionsData === void 0 ? void 0 : electionsData.IDKeyInListing] : '000', "-").concat(con === null || con === void 0 ? void 0 : con.id), "_self") : "";
                          },
                          style: electionsData !== null && electionsData !== void 0 && electionsData.ShowProfileFromListing && (con === null || con === void 0 ? void 0 : con.candidate_name) != 'NOTA' ? {
                            // textAlign: "center",
                            cursor: "pointer",
                            textDecoration: "underline",
                            // fontSize: "18px" 
                            maxWidth: "170px"
                          } : {
                            maxWidth: "170px"
                          },
                          children: con === null || con === void 0 ? void 0 : con.candidate_name
                        })]
                      }) : "Result Awaited"
                    })]
                  }, index) : /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                    className: index % 2 !== 0 ? "oddColor" : "",
                    style: {
                      letterSpacing: "normal",
                      fontSize: "15px"
                    },
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                      onClick: function onClick() {
                        return window.open("".concat("https://www.thelallantop.com").concat(router.asPath, "/").concat(con === null || con === void 0 ? void 0 : con.seat_name.toLowerCase().replace(/[^a-zA-Z ]/g, "").split(" ").join("-"), "-constituency-result/").concat(con === null || con === void 0 ? void 0 : con.id), "_self");
                      },
                      style: {
                        textAlign: "center",
                        cursor: "pointer",
                        textDecoration: "underline"
                      },
                      children: "".concat(con === null || con === void 0 ? void 0 : con.constitutency_hi, " (").concat(con === null || con === void 0 ? void 0 : con.seat_name, ")")
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                      style: {
                        paddingLeft: "30px",
                        fontSize: "18px"
                      },
                      children: (con === null || con === void 0 ? void 0 : con.party_name) === "Result Awaited" ? "Result Awaited" : dryRun == true ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                          src: con === null || con === void 0 ? void 0 : con.party_logo,
                          style: {
                            marginRight: "20px"
                          },
                          width: "25px",
                          height: "25px"
                        }), con === null || con === void 0 ? void 0 : con.party_name]
                      }) : "Result Awaited"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                      className: "winner-name",
                      style: {
                        padding: "10px",
                        display: "flex",
                        fontSize: "18px",
                        // justifyContent: "space-between",
                        justifyContent: "space-between"
                      },
                      children: (con === null || con === void 0 ? void 0 : con.candidate_name) === "Result Awaited" ? "Result Awaited" : dryRun == true ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          //add link here
                          onClick: function onClick() {
                            var _ref3;

                            electionsData.ShowProfileFromListing && (con === null || con === void 0 ? void 0 : con.candidate_name) != 'NOTA' ? window.open("".concat("https://www.thelallantop.com", "/election/").concat(props === null || props === void 0 ? void 0 : props.electionState, "/candidate-").concat((_ref3 = (con === null || con === void 0 ? void 0 : con.candidate_name) || (con === null || con === void 0 ? void 0 : con.name)) === null || _ref3 === void 0 ? void 0 : _ref3.toLowerCase().replace(/[^a-zA-Z ]/g, "").split(" ").join("-"), "-").concat(electionsData !== null && electionsData !== void 0 && electionsData.IDKeyInListing ? con === null || con === void 0 ? void 0 : con[electionsData === null || electionsData === void 0 ? void 0 : electionsData.IDKeyInListing] : '000', "-").concat(con === null || con === void 0 ? void 0 : con.id), "_self") : "";
                          } // style={{
                          //   maxWidth: "170px",
                          // }}
                          ,
                          style: electionsData !== null && electionsData !== void 0 && electionsData.ShowProfileFromListing && (con === null || con === void 0 ? void 0 : con.candidate_name) != 'NOTA' ? {
                            // textAlign: "center",
                            cursor: "pointer",
                            textDecoration: "underline",
                            // fontSize: "18px" 
                            maxWidth: "170px"
                          } : {
                            maxWidth: "170px"
                          },
                          children: con === null || con === void 0 ? void 0 : con.candidate_name
                        }), (con === null || con === void 0 ? void 0 : con.seat_status) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          width: "26%",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                            src: (con === null || con === void 0 ? void 0 : con.seat_status) === "WON" ? "https://static.thelallantop.com/images/post/1728033937028_thumbs_up.webp" : (con === null || con === void 0 ? void 0 : con.seat_status) === "TRAILING" ? "https://static.thelallantop.com/images/post/1728033833372_arrow_down.webp" : (con === null || con === void 0 ? void 0 : con.seat_status) === "LEADING" ? "https://static.thelallantop.com/images/post/1728033863072_arrow_up.webp" : "https://static.thelallantop.com/images/post/1728033907858_thumbs_down.webp" // style={{ marginLeft: "20px" }}
                            ,
                            width: "25px",
                            height: "25px"
                          })
                        })]
                      }) : "Result Awaited"
                    })]
                  }, index)
                });
              })]
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "electionYatra-outer-home",
        style: {
          width: "100% "
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "electionYatra-header",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/assets/images/election-icon.png",
              width: "35px",
              height: "35px",
              alt: "election-icon"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              style: {
                marginLeft: "10px",
                display: "inline-block"
              },
              children: "\u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "election-aurDekhe",
            onClick: function onClick() {
              return router.push("/election");
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              style: {
                marginRight: "10px"
              },
              children: "\u0914\u0930 \u0926\u0947\u0916\u0947\u0902 "
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/assets/images/arrow.png",
              width: "10px",
              height: "10px"
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "electionYatra-columns",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "checkMobileOrNot",
            href: "".concat((_electionTopicData$ = electionTopicData[0]) === null || _electionTopicData$ === void 0 ? void 0 : _electionTopicData$.permalink),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "electionYatra-second election-mobile",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "electionYatra-second-top",
                style: {
                  position: "relative"
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: (_electionTopicData$2 = electionTopicData[0]) === null || _electionTopicData$2 === void 0 ? void 0 : _electionTopicData$2.headingImageUrl
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
                  className: ((_electionTopicData$3 = electionTopicData[0]) === null || _electionTopicData$3 === void 0 ? void 0 : _electionTopicData$3.type) == 'video' ? "icon-play-circle" : 'icon-cat-read',
                  width: "500px",
                  height: "500px",
                  style: {
                    color: "white",
                    position: "absolute",
                    left: "2px",
                    bottom: "-5px",
                    width: "500px"
                  }
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "electionYatra-second-bottom",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  children: (_electionTopicData$4 = electionTopicData[0]) === null || _electionTopicData$4 === void 0 ? void 0 : _electionTopicData$4.title
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between"
            },
            children: electionTopicData.slice(1).map(function (x, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "".concat(x === null || x === void 0 ? void 0 : x.permalink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "electionYatra-first",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "electionYatra-first-div",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      style: {
                        // flex: "0 0 38%",
                        position: "relative",
                        justifyContent: "center",
                        alignContent: "center",
                        alignItems: "center"
                      },
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        src: x === null || x === void 0 ? void 0 : x.headingImageUrl,
                        width: "160px",
                        height: "90px"
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
                        className: (x === null || x === void 0 ? void 0 : x.type) == 'video' ? "icon-play-circle" : 'icon-cat-read',
                        style: {
                          color: "white",
                          position: "absolute",
                          left: "2px",
                          bottom: "-5px"
                        }
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "electionYatra-first-div-right",
                      style: {
                        flex: "0 0 60%"
                      },
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          style: {
                            overflow: "hidden"
                          },
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                            style: {
                              display: "-webkit-box",
                              lineHeight: "22px",
                              WebkitLineClamp: "3",
                              WebkitBoxOrient: "vertical",
                              marginTop: "5px"
                            },
                            className: "chunav-yatra-small-title",
                            children: x === null || x === void 0 ? void 0 : x.title
                          })
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        style: {
                          display: "flex",
                          gap: "1rem"
                        }
                      })]
                    })]
                  })
                })
              }, index);
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            style: {
              width: "100%"
            },
            className: "checkDesktopOrNot",
            href: "".concat((_electionTopicData$5 = electionTopicData[0]) === null || _electionTopicData$5 === void 0 ? void 0 : _electionTopicData$5.permalink),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "electionYatra-second election-desktop",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "electionYatra-second-top",
                style: {
                  position: "relative"
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: (_electionTopicData$6 = electionTopicData[0]) === null || _electionTopicData$6 === void 0 ? void 0 : _electionTopicData$6.headingImageUrl
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
                  className: "icon-play-circle",
                  width: "500px",
                  height: "500px",
                  style: {
                    color: "white",
                    position: "absolute",
                    left: "2px",
                    bottom: "-5px",
                    width: "500px"
                  }
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "electionYatra-second-bottom",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  children: (_electionTopicData$7 = electionTopicData[0]) === null || _electionTopicData$7 === void 0 ? void 0 : _electionTopicData$7.title
                })
              })]
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Container/* default */.Z, {
        align: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "container-row py-2",
          align: "center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            style: {
              fontSize: "11px",
              color: "#b7b7b7",
              textAlign: "center",
              marginBottom: "0px"
            },
            children: "Advertisement"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            id: size.width > 600 ? "div-gpt-ad-1701945220410-1" : "div-gpt-ad-1701946028239-1",
            style: {
              minWidth: "300px",
              minHeight: size.width > 600 ? "100px" : "260px",
              display: "block !important",
              alignContent: "center",
              textAlign: "-webkit-center"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
              type: "text/javascript",
              dangerouslySetInnerHTML: {
                __html: size.width > 600 ? "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-1')})" : "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-1')})"
              }
            })
          })]
        }), " "]
      })]
    })]
  });
}

/* harmony default export */ var vidhansabha_KaunJeetaD = (KaunJeetaD);
// EXTERNAL MODULE: ./src/pages/404.js
var _404 = __webpack_require__(7725);
;// CONCATENATED MODULE: ./src/pages/election/[electionState]/results/index.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


// import KaunJeetaJK from "components/vidhansabha/KaunJeetaJK";


var __N_SSP = true;
function kaunJeetaIndex(props) {
  return props.found ? /*#__PURE__*/(0,jsx_runtime.jsx)(vidhansabha_KaunJeetaD, _objectSpread({}, props)) : /*#__PURE__*/(0,jsx_runtime.jsx)(_404["default"], {});
}

/***/ }),

/***/ 18945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83977);

var firebaseConfig = {
  apiKey: "AIzaSyA43bFX7ueF-JM0g-weOR0HxqDuQRkXydg",
  authDomain: "thelallantop-5296b.firebaseapp.com",
  databaseURL: "https://thelallantop-5296b.firebaseio.com",
  projectId: "thelallantop-5296b",
  storageBucket: "thelallantop-5296b.appspot.com",
  messagingSenderId: "928164060644",
  appId: "1:928164060644:web:7490092b73d4b3f714bbf1",
  measurementId: "G-L0B4Q7N010"
}; // const firebaseConfig = {
//   apiKey: "AIzaSyBd9I1B7T3yq5xXY5HoU69k1OIcGSBbnHE",
//   authDomain: "lallantop-dev-c5e4c.firebaseapp.com",
//   databaseURL: "https://lallantop-dev-c5e4c-default-rtdb.firebaseio.com",
//   projectId: "lallantop-dev-c5e4c",
//   storageBucket: "lallantop-dev-c5e4c.appspot.com",
//   messagingSenderId: "606538662701",
//   appId: "1:606538662701:web:b9fd13f9130e72f8f689a4",
//   measurementId: "G-KGFH4PGD46"
// };

var app = (0,firebase_app__WEBPACK_IMPORTED_MODULE_0__/* .initializeApp */ .ZF)(firebaseConfig, "appcheck");
/* harmony default export */ __webpack_exports__["Z"] = (app);

/***/ }),

/***/ 30148:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/election/[electionState]/results",
      function () {
        return __webpack_require__(73557);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,3977,2971,5613,532,2888,179], function() { return __webpack_exec__(30148); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);